import { useTheme } from '@emotion/react';
import styled from '@emotion/styled';
import { CheckCircle2, Mail, Zap } from 'lucide-react';
import React from 'react';

export const ActorLegendContainer = styled('div')<{
  flex?: string;
}>((p) => ({
  display: 'flex',
  flex: p.flex || `0 1 auto`,
  backgroundColor: p.theme.custom.colors.gray.w200,
  borderRadius: p.theme.custom.border.radius()
}));

export const ActorIconContainer = styled('div')<{
  color: string;
  fullBorderRadius?: boolean;
}>((p) => ({
  display: 'flex',
  alignItems: 'center',
  color: p.theme.custom.colors.gray.white,
  backgroundColor: p.color,
  padding: p.fullBorderRadius
    ? `${p.theme.spacing(0.3)}px`
    : `0 ${p.theme.spacing(0.5)}px`,
  borderRadius: p.fullBorderRadius
    ? `${p.theme.custom.border.radius(0.5)}px`
    : `${p.theme.custom.border.radius()}px 0 0 ${p.theme.custom.border.radius()}px`
}));

export const ActorLegendContent = styled('div')((p) => ({
  fontSize: p.theme.custom.fontSize.s,
  fontWeight: p.theme.typography.fontWeightMedium,
  color: p.theme.custom.colors.gray.w500,
  padding: `1px ${p.theme.spacing()}px 1px ${p.theme.spacing(0.75)}px`
}));

const CCLabel = styled('span')((p) => ({
  fontSize: 10,
  fontWeight: p.theme.typography.fontWeightBold,
  color: p.theme.custom.colors.gray.white,
  lineHeight: 1
}));

export const ActorLegend: React.FC<{
  type: 'message' | 'task' | 'automation';
  color: string;
  flex?: string;
  isCCView?: boolean;
}> = ({ type, color, children, flex, isCCView }) => {
  const theme = useTheme();
  const ICON_SIZE = 16;
  const iconColor = isCCView ? theme.custom.colors.gray.w400 : color;
  return (
    <ActorLegendContainer flex={flex}>
      <ActorIconContainer color={iconColor} fullBorderRadius={!children}>
        {isCCView ? (
          <CCLabel>CC</CCLabel>
        ) : (
          <>
            {type === 'message' && <Mail size={ICON_SIZE} />}
            {type === 'task' && <CheckCircle2 size={ICON_SIZE} />}
            {type === 'automation' && <Zap size={ICON_SIZE} />}
          </>
        )}
      </ActorIconContainer>
      {children && <ActorLegendContent>{children}</ActorLegendContent>}
    </ActorLegendContainer>
  );
};
